import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Cell, StyledCellIcon } from './RecordingOverviewWidgetCell';

import type { RecordingOverviewWidgetCellParams } from './RecordingOverviewWidgetCell';

// @FIXME Temporary solution until we have a better way to do this.
// We need to keep the cell's width consistent with singular and plural strings.
const StyledCell = styled(Cell)`
  text-align: left;
  width: 80px;
`;

export const RecordingOverviewWidgetCellUturns = ({
  recording,
}: RecordingOverviewWidgetCellParams): JSX.Element | null => {
  const { t } = useTranslation();

  if (!recording) return null;

  return (
    <StyledCell>
      <StyledCellIcon icon="uturn" />
      {t('common:recordings.recordings-overview.widget.cells.u-turn', {
        count: recording.uTurnCount,
      })}
    </StyledCell>
  );
};
